import {
  ExpandLess,
  ExpandMore,
  KeyboardDoubleArrowDown,
  KeyboardDoubleArrowUp,
  UnfoldMore,
} from '@mui/icons-material'
import { Box, MenuItem, Typography } from '@mui/material'
import { type SimpleSelectOption } from '@workwave-tidal/core/components'

import { BulkSelectValue } from '@/components/form/tidal-form/fields/Bulk/BulkSelect'

import { form } from '../../../formState'
import { useTexts } from './hooks/useTexts'

export function Priority() {
  const texts = useTexts()

  const getPriorityValues = (): SimpleSelectOption<string>[] => [
    {
      label: texts.highest,
      value: '20',
      icon: <KeyboardDoubleArrowUp color="error" />,
    },
    {
      label: texts.higher,
      value: '10',
      icon: <ExpandLess color="warning" />,
    },
    {
      label: texts.normal,
      value: '0',
      icon: <UnfoldMore color="action" />,
    },
    {
      label: texts.lower,
      value: '-10',
      icon: <ExpandMore color="info" />,
    },
    {
      label: texts.lowest,
      value: '-20',
      icon: <KeyboardDoubleArrowDown color="success" />,
    },
  ]

  const priorityValues: SimpleSelectOption<string>[] = getPriorityValues()

  // Custom render for options in the dropdown
  const renderPriorityOption = (option: SimpleSelectOption<string>) => (
    <MenuItem key={option.value} value={option.value}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {option.icon}
        <Typography variant="body1">{option.label}</Typography>
      </Box>
    </MenuItem>
  )

  // Custom render for selected value
  const renderPriorityValue = (option: SimpleSelectOption<string>) => {
    if (!option) return null
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {option.icon}
        <Typography variant="body1">{option.label}</Typography>
      </Box>
    )
  }

  return (
    <form.BulkSelect
      name="priority"
      mixedLabel={texts.mixed}
      options={priorityValues}
      label={texts.priority}
      testId="priority"
      parse={(option: BulkSelectValue) =>
        option && option.status === 'exact' ? option : undefined
      }
      format={(option: BulkSelectValue | null | undefined) =>
        option && option.status === 'exact' ? option : (option as BulkSelectValue)
      }
      simpleSelectProps={{
        renderOptions: options => options.map(option => renderPriorityOption(option)),
        renderValue: renderPriorityValue,
      }}
    />
  )
}
